import React, { PropsWithChildren } from "react";

import BoxWithIcon, { Props } from "@/components/shared/BoxWithIcon";

export default function ErrorBox({ children, ...props }: PropsWithChildren<Props>) {
  const boxProps = { borderColor: "red.400", color: "red.400", ...props };
  return <BoxWithIcon {...boxProps}>{children}</BoxWithIcon>;
}
